<template>
  <b-modal
    v-model="localShow"
    centered
    footer-class="member-tag-edit-dialog__footer">
    <template #modal-header>
      <div class="member-tag-edit-dialog__header">
        <div class="member-tag-edit-dialog__header-title">
          <span class="material-icons member-tag-edit-dialog__header-icon">group</span>
          <span class="member-tag-edit-dialog__header-name">{{ department && department.name }}</span>
        </div>
        <button
          class="member-tag-edit-dialog__header-close"
          @click="localShow = false">
          <span class="material-icons">close</span>
        </button>
      </div>
    </template>
    <div class="member-tag-edit-dialog">
      <div
        v-for="member in members"
        :key="member.id"
        class="member-tag-edit-dialog__member">
        <div
          class="member-tag-edit-dialog__member-row"
          @click="toggleMember(member.id)">
          <div class="member-tag-edit-dialog__member-info">
            <user-avatar
              :user="member"
              size="sm" />
            <span class="member-tag-edit-dialog__member-name">
              <UserTag :user="member" />
              {{ member.name }}
            </span>
          </div>
          <span class="material-icons member-tag-edit-dialog__chevron">
            {{ openMemberId === member.id ? 'expand_less' : 'expand_more' }}
          </span>
        </div>
        <b-collapse
          :visible="openMemberId === member.id">
          <div class="member-tag-edit-dialog__tags d-flex">
            <div class="member-tag-edit-dialog__tag-section">
              <div class="member-tag-edit-dialog__tag-label">
                タグ1
              </div>
              <b-form-radio
                :checked="member.tag1"
                :value="null"
                class="member-tag-edit-dialog__radio-none"
                @change="(val) => onChangeTag(member, 'tag1', val)">
                選択なし
              </b-form-radio>
              <b-form-radio-group
                :checked="member.tag1"
                :options="tag1SelectableOptions"
                class="member-tag-edit-dialog__radio-group"
                @change="(val) => onChangeTag(member, 'tag1', val)" />
            </div>
            <div class="member-tag-edit-dialog__tag-section">
              <div class="member-tag-edit-dialog__tag-label">
                タグ2
              </div>
              <b-form-radio
                :checked="member.tag2"
                :value="null"
                class="member-tag-edit-dialog__radio-none"
                @change="(val) => onChangeTag(member, 'tag2', val)">
                選択なし
              </b-form-radio>
              <b-form-radio-group
                :checked="member.tag2"
                :options="tag2SelectableOptions"
                class="member-tag-edit-dialog__radio-group"
                @change="(val) => onChangeTag(member, 'tag2', val)" />
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <template #modal-footer>
      <b-button
        variant="secondary"
        @click="localShow = false">
        閉じる
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import UserAvatar from '@/components/parts/UserAvatar.vue'
import UserTag from '@/components/parts/UserTag.vue'
import { tag1SelectableOptions, tag2SelectableOptions } from '@/helper/tag'

export default {
  components: { UserAvatar, UserTag },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    department: {
      type: Object,
      default: null,
    },
    initialMembers: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      members: [],
      openMemberId: null,
    }
  },
  computed: {
    tag1SelectableOptions() { return tag1SelectableOptions },
    tag2SelectableOptions() { return tag2SelectableOptions },
    localShow: {
      get() {
        return this.show
      },
      set(v) {
        this.$emit('update:show', v)
      },
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.applyMembers(this.initialMembers)
      } else {
        this.members = []
        this.openMemberId = null
      }
    },
  },
  methods: {
    applyMembers(source) {
      this.members = (source || []).map((m) => ({
        ...m,
        tag1: m.tag1 ?? null,
        tag2: m.tag2 != null ? String(m.tag2) : null,
      }))
    },
    toggleMember(memberId) {
      this.openMemberId = this.openMemberId === memberId ? null : memberId
    },
    async onChangeTag(member, tagKey, value) {
      const previousValue = member[tagKey]
      this.$set(member, tagKey, value)
      try {
        await this.$axios.patch(`/accounts/manage_staff/${member.id}/`, {
          [tagKey]: value,
        })
        this.$emit('tag-updated', this.department.id)
      } catch (e) {
        this.$set(member, tagKey, previousValue)
        this.$store.commit('notify/set', { isUnknownError: true, type: 'danger' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.member-tag-edit-dialog {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  &__header-title {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__header-icon {
    color: #555;
    font-size: 20px;
  }

  &__header-name {
    font-size: 15px;
    font-weight: bold;
  }

  &__header-close {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: #9e9e9e;
    display: flex;
    align-items: center;

    &:hover {
      color: #555;
    }

    .material-icons {
      font-size: 22px;
    }
  }

  &__member {
    border-bottom: 1px solid #e0e0e0;

    &:last-child {
      border-bottom: none;
    }
  }

  &__member-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    cursor: pointer;
  }

  &__member-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__member-name {
    font-size: 14px;
  }

  &__chevron {
    color: #9e9e9e;
    font-size: 20px;
  }

  &__tags {
    padding: 16px 0 12px;
    gap: 24px;
  }

  &__tag-section {
    flex: 1;
    margin-bottom: 12px;
  }

  &__tag-label {
    font-weight: bold;
    font-size: 13px;
    margin-bottom: 8px;
  }

  &__radio-none {
    margin-bottom: 6px;
    padding-bottom: 6px;
    border-bottom: 1px solid #e0e0e0;
  }

  &__radio-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(10, auto);
    grid-auto-flow: column;
    gap: 4px;
  }
}
</style>

<style>
.member-tag-edit-dialog__footer {
  justify-content: center;
}
</style>
